const AUTHENTICATION_TYPES = ["auth2", "apikey"];
export const IS_SANDBOX = process.env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER = process.env.REACT_APP_EXTENSION_IDENTIFIER;
export const DATA_CENTER_URL_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center_URL";
export const DATA_CENTER_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center";

export const ORG_ID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Organization_ID";

export const API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__API_KEY";

export const Z_API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZAPI_Key";

export const ZUID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZUID";

export const CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME =
  "Credential_Of_Login_User_Zoho";

export const CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME =
  "Credential_Of_Login_User_SERVICE";

export const SERVICE_API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__SMS_API_KEY";

export const ZOHO_CONN = process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho";
export const SERVICE_CONN =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__cellcast";
export const CLIQ_CONN = process.env.REACT_APP_EXTENSION_IDENTIFIER + "__cliq";

export const SERVICE_NAME = "cellcast";
export const SERVICE_AUTHENTICATION_TYPE = AUTHENTICATION_TYPES[1];

export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVER_URL;
export const SERVICE_API_URL = process.env.REACT_APP_API_SERVER_URL;

export const ServiceList = [
  {
    displayLabel: "Zoho Work Drive",
    apiName: "workdrive",
  },
  {
    displayLabel: "Share Point",
    apiName: "sharepoint",
  },
  // {
  //   displayLabel: "Google Drive",
  //   apiName: "google drive",
  // },
  // {
  //   displayLabel: "One Drive",
  //   apiName: "onedrive",
  // },
  // {
  //   displayLabel: "Drop Box",
  //   apiName: "dropbox",
  // },
];

export const LOG_MODULE_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Attachment_Logs";

export const ZOHO_CONN_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho";
export const WORKDRIVE_CONN_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__workdrive";
export const SHAREPOINT_CONN_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__sharepoint";
export const GOOGLE_DRIVE_CONN_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__google drive";
export const dateFormat = "YYYY-MM-DD";
